<template>

	<Dashboard :type="type"></Dashboard>

</template>

<script>

import Dashboard from '../../components/dashboard/Dashboard.vue'

export default {
	name: 'experience',
	components: {
		'Dashboard': Dashboard
	},

	data () {
		return {
			type: 'settings'
		}
	}
}

</script>
